import { useRouter } from 'next/navigation';
import { TD } from '@/components/DesignLibrary/Table';
import Button from '@/components/DesignLibrary/Button';
import s from './OpenDetails.module.scss';

export type Props = {
  type: 'open-details';
  label: string;
  icon?: React.ReactNode;
  href: string;
  cta: string;
  newTab?: boolean;
};

type InternalProps = Props & {
  onClick: () => void;
};

const OpenDetailsCell: React.FC<InternalProps> = ({ label, href, icon, cta, onClick, newTab }) => {
  const router = useRouter();
  const handleClick = (): void => {
    if (newTab) {
      window.open(href, '_blank');
    } else {
      router.push(href);
      onClick();
    }
  };
  if (!href) {
    return <TD label="—" compact />;
  }

  return (
    <TD compact>
      <p className={s.label}><span className="caption">{label}</span>{icon}</p>
      <Button variant='secondary' size="xs" onClick={handleClick} className={s.cta}>{cta}</Button>
    </TD>
  );
};

export default OpenDetailsCell;
